<template>
  <div class="base-view-layout">
    <div class="header">
      <slot name="header" />
    </div>
    <div class="body">
      <slot name="body" />
    </div>
    <div class="footer flex justify-between">
      <div class="pagination-container" v-if="showPagination"></div>
      <bdg-button
        class="w-full md:w-auto uppercase"
        before-icon-class="fal fa-plus-square fa-fw"
        :is-ghost="true"
        @click.native="openSideDrawer"
        v-if="sideDrawerComponent && sideDrawerActionText"
      >
        {{ sideDrawerActionText }}
      </bdg-button>
    </div>
  </div>
</template>

<script>
import BdgButton from "../../elements/BdgButton";

export default {
  name: "BaseViewLayout",
  components: { BdgButton },
  props: {
    sideDrawerComponent: { type: Object, default: null },
    sideDrawerComponentData: { type: Object, default: undefined },
    sideDrawerActionText: { type: String, default: null },
    showPagination: Boolean
  },
  watch: {
    sideDrawerData(val) {
      if (val && this.sideDrawerComponent) {
        this.openSideDrawer();
      }
    }
  },
  methods: {
    openSideDrawer() {
      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: this.sideDrawerComponent,
        createEditComponentData: this.sideDrawerComponentData,
        createEditComponentIsShown: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.base-view-layout {
  @apply flex flex-col justify-between w-full;

  @screen md {
    @apply px-12 py-16;
  }

  .header {
    @apply mb-2 p-4;

    @screen md {
      @apply mb-6 p-0;
    }
  }

  .footer {
    &:not(:empty) {
      @apply px-4 pt-6 pb-8;

      @screen md {
        @apply mt-6;
      }
    }

    @screen md {
      @apply p-0;
    }
  }
}
</style>
